// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__Zn9Ln","fixed":"header_fixed__NC_ap","tool":"header_tool__ohvh4","searchIcon":"header_searchIcon__jNB8f"};